import { NgxUiLoaderConfig } from "ngx-ui-loader"; 

const const_center ='center-center'
export const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
	"bgsColor": "red",
	"bgsOpacity": 0.5,
	"bgsPosition": "bottom-right",
	"bgsSize": 60,
	"bgsType": "ball-spin-clockwise",
	"blur": 5,
	"delay": 0,
	"fastFadeOut": true,
	"fgsColor": "red",
	"fgsPosition": const_center,
	"fgsSize": 60,
	"fgsType": "ball-spin-clockwise",
	"gap": 24,
	"logoPosition": const_center,
	"logoSize": 120,
	"logoUrl": "",
	"masterLoaderId": "master",
	"overlayBorderRadius": "0",
	"overlayColor": "rgba(40, 40, 40, 0.8)",
	"pbColor": "red",
	"pbDirection": "ltr",
	"pbThickness": 3,
	"hasProgressBar": true,
	"text": "",
	"textColor": "#FFFFFF",
	"textPosition": const_center,
	"maxTime": -1,
	"minTime": 300
};
